<label *ngIf="control">
  <span *ngIf="control.value" class="material-icons">check_box</span>
  <span *ngIf="!control.value" class="material-icons">check_box_outline_blank</span>
  <span *ngIf="label">{{ label }}</span>
  <input type="checkbox" [formControl]="control" />
</label>
